
  import { defineComponent, PropType } from 'vue';
  import useVuelidate from '@vuelidate/core';
  import { requiredIf } from '@vuelidate/validators';

  import TreeSelectionProductsModal from './TreeSelectionProductsModal.vue';
  import { TProductItem, TProductsTreeFetcher } from './types';

  type TTreeSelectionProductsData = {
    catalogModal: boolean;
  };

  export default defineComponent({
    name: 'TreeSelectionProducts',
    emits: ['updateSelectedIDs', 'selectSelectedIDs'],
    components: {
      TreeSelectionProductsModal,
    },
    props: {
      selectedIdsProps: {
        type: Array as PropType<(number | string)[]>,
        default: () => [],
      },
      updateSelectedItems: {
        type: Function as PropType<(value: TProductItem[]) => void>,
      },
      multiple: {
        type: Boolean,
        default: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
      isDirtyValidation: {
        type: Boolean,
        default: false,
      },
      selectGroupsOnly: {
        type: Boolean,
        default: false,
      },
      selectLeafsOnly: {
        type: Boolean,
        default: false,
      },
      codes: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      fetcher: {
        type: Function as PropType<TProductsTreeFetcher>,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data(): TTreeSelectionProductsData {
      return {
        catalogModal: false,
      };
    },
    methods: {
      async updateProducts(selectedIds: number[]): Promise<void> {
        this.selectedIDs = selectedIds;
        this.catalogModal = false;
        this.$emit('selectSelectedIDs', this.selectedIDs);
      },

      closeCatalog() {
        this.catalogModal = false;
      },

      deleteAll() {
        this.selectedIDs = [];
      },
    },
    computed: {
      selectedIDs: {
        get() {
          return this.selectedIdsProps;
        },
        set(value: number[]) {
          this.$emit('updateSelectedIDs', value);
        },
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        selectedIdsProps: {
          required: requiredIf(this.required),
        },
        $autoDirty: this.isDirtyValidation,
      };
    },
  });
